interface PdpHeaderBackgroundColors {
  headerBackgroundColor?: string;
  headerCustomizationBackgroundColor?: string;
  headerReviewBackgroundColor?: string;
}

interface PdpHeaderContext {
  isProductCustomization: boolean;
  isProductReview: boolean;
}

export const getPdpHeaderBackgroundColor = (
  {
    headerBackgroundColor,
    headerCustomizationBackgroundColor,
    headerReviewBackgroundColor,
  }: PdpHeaderBackgroundColors,
  { isProductCustomization, isProductReview }: PdpHeaderContext
): string | undefined => {
  if (isProductCustomization) {
    return headerCustomizationBackgroundColor ?? headerBackgroundColor;
  }

  if (isProductReview) {
    return headerReviewBackgroundColor ?? headerBackgroundColor;
  }

  return headerBackgroundColor;
};
